import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class DashboardStockItems extends Component{ 

    constructor(props){
      super(props);

      this.state={
          stockcover:[],
          modalTitle:"",
          stockcoveritemid:0,
          fyname_ist:"",
          regionname_ist:"",
          warehousename_ist:"",
          sapcode_ist:"",
          productdescription_ist:"",
          july_ist:"",
          august_ist:"",
          september_ist:"",
          october_ist: "",
          november_ist: "",
          december_ist: "",
          january_ist: "",
          february_ist: "",
          march_ist: "",
          april_ist: "",
          may_ist: "",
          june_ist:"",

          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          InboundIdFilter:"",
          SapCodeFilter:"",
          ProductDescriptionFilter:"",
          CurrentYearFilter:"",
          stockcoverWithoutFilter:[],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,
          
          // Pagination state
          currentPage: 1,
          totalPages: 1,
          pageSize: 100,
          nextPageUrl: null,
          previousPageUrl: null,
      }
      this.handleNextPage = this.handleNextPage.bind(this);
      this.handlePreviousPage = this.handlePreviousPage.bind(this);
  }

  FilterFn(){
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var InboundIdFilter = this.state.InboundIdFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;
    var SapCodeFilter = this.state.SapCodeFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;

    var filteredData=this.state.stockcoverWithoutFilter.filter(
        function(el){
            return el.regionname_ist.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehousename_ist.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname_ist.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
            el.stockcoveritemid.toString().toLowerCase().includes(
            InboundIdFilter.toString().trim().toLowerCase()
        )&&  
        el.sapcode_ist.toString().toLowerCase().includes(
        SapCodeFilter.toString().trim().toLowerCase()
    )&&  
    el.productdescription_ist.toString().toLowerCase().includes(
    ProductDescriptionFilter.toString().trim().toLowerCase()
)
        }
    );

    this.setState({stockcover:filteredData, currentPage: 1});

}

sortResult(prop,asc){
  var sortedData=this.state.stockcoverWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({stockcover:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }



changeInboundIdFilter = (e)=>{
    this.state.InboundIdFilter=e.target.value;
    this.FilterFn();
  }

  changeSapCodeFilter = (e)=>{
    this.state.SapCodeFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }



  // Server-side search (paginated) - similar to WarehousesStockProcurement.jsx
  searchStockItems = async () => {
    const {
      FiscalYearFilter,
      RegionNameFilter,
      WarehouseNameFilter,
      SapCodeFilter,
      ProductDescriptionFilter,
      InboundIdFilter,
    } = this.state;

    const queryParams = new URLSearchParams();

    // Keep keys flexible (backend may accept some/all of these)
    if (FiscalYearFilter) {
      queryParams.append("year", FiscalYearFilter);
      queryParams.append("fyname", FiscalYearFilter);
      queryParams.append("fyname_ist", FiscalYearFilter);
    }
    if (RegionNameFilter) {
      queryParams.append("region", RegionNameFilter);
      queryParams.append("regionname", RegionNameFilter);
      queryParams.append("regionname_ist", RegionNameFilter);
    }
    if (WarehouseNameFilter) {
      queryParams.append("warehouse", WarehouseNameFilter);
      queryParams.append("warehousename", WarehouseNameFilter);
      queryParams.append("warehousename_ist", WarehouseNameFilter);
    }
    if (SapCodeFilter) {
      queryParams.append("sapcode", SapCodeFilter);
      queryParams.append("sapcode_ist", SapCodeFilter);
    }
    if (ProductDescriptionFilter) {
      queryParams.append("product", ProductDescriptionFilter);
      queryParams.append("productdescription", ProductDescriptionFilter);
      queryParams.append("productdescription_ist", ProductDescriptionFilter);
    }
    if (InboundIdFilter) {
      queryParams.append("id", InboundIdFilter);
      queryParams.append("stockcoveritemid", InboundIdFilter);
    }

    const apiUrl = `${variables.API_URL}api/stockcover_items/?${queryParams.toString()}`;

    this.setState({ loading: true, currentPage: 1 });
    this.refreshList(apiUrl);
  };

  // Clear filters and reload first page - similar to WarehousesStockProcurement.jsx
  clearFilterStockItems = () => {
    this.setState(
      {
        RegionNameFilter: "",
        WarehouseNameFilter: "",
        FiscalYearFilter: "",
        InboundIdFilter: "",
        SapCodeFilter: "",
        ProductDescriptionFilter: "",
        CurrentYearFilter: "",
        currentPage: 1,
        nextPageUrl: null,
        previousPageUrl: null,
        totalPages: 1,
      },
      () => {
        // Clear all filter inputs in the DOM (most inputs are uncontrolled)
        const filterInputs = document.querySelectorAll(".form-control");
        filterInputs.forEach((input) => {
          if (input.placeholder === "Filter") {
            input.value = "";
          }
        });

        this.setState({ loading: true });
        this.refreshList();
      }
    );
  };

refreshList = (url = null) => {
    // Extract endpoint from full URL if provided, otherwise use default
    const endpoint = url ? url.replace(variables.API_URL + 'api', '') : '/stockcover_items/';
    axiosService.get(endpoint)
      .then((response) => {
        const data = response.data;
        // Check if response has pagination structure (count, results, next, previous)
        if (data.results !== undefined) {
          // Paginated response
          const totalPages = Math.ceil(data.count / this.state.pageSize);
          this.setState({ 
            stockcover: data.results || [],
            stockcoverWithoutFilter: data.results || [],
            loading: false,
            nextPageUrl: data.next,
            previousPageUrl: data.previous,
            totalPages: totalPages
          });
        } else {
          // Non-paginated response (backward compatibility)
          this.setState({ 
            stockcover: data || [],
            stockcoverWithoutFilter: data || [],
            loading: false,
            nextPageUrl: null,
            previousPageUrl: null,
            totalPages: 1
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  // Handle next page
  handleNextPage = () => {
    if (this.state.nextPageUrl) {
      this.setState({ 
        loading: true,
        currentPage: this.state.currentPage + 1 
      });
      this.refreshList(this.state.nextPageUrl);
    }
  };

  // Handle previous page
  handlePreviousPage = () => {
    if (this.state.previousPageUrl) {
      this.setState({ 
        loading: true,
        currentPage: this.state.currentPage - 1 
      });
      this.refreshList(this.state.previousPageUrl);
    }
  };



componentDidMount(){
  this.refreshList();
}



render(){
  const {
      stockcover,
      modalTitle,
      stockcoveritemid,
      warehousename_ist,
      regionname_ist,
      fyname_ist,
      july_ist,
      august_ist,
      september_ist,
      october_ist,
      november_ist,
      december_ist,
      january_ist,
      february_ist,
      march_ist,
      april_ist,
      may_ist,
      june_ist,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSapCodeFilter}
      placeholder="Filter"/>
      </div>
      Product SapCode / SKU
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>
      </div>
      ProductDescription
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex m-2 flex-row align-items-center justify-content-center gap-1">
        <button 
          type="button"
          className="btn btn-primary"
          style={{ fontSize: "12px" }}
          onClick={this.searchStockItems}
        >
          Search
        </button>
        <button 
          type="button"
          className="btn btn-secondary"
          style={{ fontSize: "12px" }}
          onClick={this.clearFilterStockItems}
        >
          Clear
        </button>
      </div>
      Jul (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr (months)
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May (months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun (months)
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {stockcover.map(dep=>
      <tr key={dep.stockcoveritemid} className="row-hover">
          <td className="table-text">{dep.fyname_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.regionname_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.sapcode_ist ?? 'N/A'}</td>
          <td className="table-text">{dep.productdescription_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.july_ist) < 6 ? 'text-danger' : ''}`}>{dep.july_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.august_ist) < 6 ? 'text-danger' : ''}`}>{dep.august_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.september_ist) < 6 ? 'text-danger' : ''}`}>{dep.september_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.october_ist) < 6 ? 'text-danger' : ''}`}>{dep.october_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.november_ist) < 6 ? 'text-danger' : ''}`}>{dep.november_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.december_ist) < 6 ? 'text-danger' : ''}`}>{dep.december_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.january_ist) < 6 ? 'text-danger' : ''}`}>{dep.january_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.february_ist) < 6 ? 'text-danger' : ''}`}>{dep.february_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.march_ist) < 6 ? 'text-danger' : ''}`}>{dep.march_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.april_ist) < 6 ? 'text-danger' : ''}`}>{dep.april_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.may_ist) < 6 ? 'text-danger' : ''}`}>{dep.may_ist ?? 'N/A'}</td>
          <td className={`table-text ${parseInt(dep.june_ist) < 6 ? 'text-danger' : ''}`}>{dep.june_ist ?? 'N/A'}</td>
          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

{/* Pagination Controls */}
<div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '10px', 
  padding: '20px',
  fontSize: '12px'
}}>
  <button 
    onClick={this.handlePreviousPage}
    disabled={!this.state.previousPageUrl || this.state.loading}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Previous
  </button>
  
  <span style={{ fontSize: '12px' }}>
    Page {this.state.currentPage} of {this.state.totalPages}
  </span>
  
  <button 
    onClick={this.handleNextPage}
    disabled={!this.state.nextPageUrl || this.state.loading}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Next
  </button>
</div>
</div>
  )
}
  }




